import * as axisone from './configs/axis-one.js';
import * as axisplisse from './configs/axis-plisse.js';
import * as plisseltd from './configs/plisse-ltd.js';
import * as setkipro from './configs/setkipro.js';
import * as moskitoscompany from './configs/moskitoscompany.js';
import * as profiledoors from './configs/profile-doors.js';
import common from './configs/common.js';

let list = [].concat(
    axisone.list,
    axisplisse.list,
    plisseltd.list,
    setkipro.list,
    moskitoscompany.list,
    profiledoors.list,
    common,
);

let page = [].concat(
    profiledoors.page,
);

let logo = [
    axisone.logo,
    axisplisse.logo,
    plisseltd.logo,
    setkipro.logo,
    moskitoscompany.logo,
    profiledoors.logo,
    'default.png'
].find(e => e !== null);

/*
 * 100  5274.63
 * 10   5274.7
 * 1    5275
 * 0.1  5280
 * 0.01 5300
 */
let precision = +[
    axisone.precision,
    axisplisse.precision,
    plisseltd.precision,
    setkipro.precision,
    moskitoscompany.precision,
    profiledoors.precision,
    100,
].find(e => e !== null);

export {list, page, logo, precision};
